<div class="k-form">
  <label class="k-form-field" for="start-datepicker">
    <span>After</span>
    <kendo-datepicker
      id="start-datepicker"
      [max]="max"
      [popupSettings]="popupSettings"
      [value]="start"
      [(ngModel)]="start"
      (valueChange)="onStartChange($event)"
    />
  </label>
  <label class="k-form-field" for="end-datepicker">
    <span>Before</span>
    <kendo-datepicker
      id="end-datepicker"
      [min]="min"
      [popupSettings]="popupSettings"
      [value]="end"
      [(ngModel)]="end"
      (valueChange)="onEndChange($event)"
    />
  </label>
</div>
